export default __webpack_public_path__ + "static/Entenda0087-81e92e8d342d29dc5c8f3f7758f8dfd3.jpg";